import CampaignScreens from "../../CampaignScreens";

import { PageTabs } from "src/app/components";
import { campaignTabs } from "./CampaignTabs.template";
import { usePermissions } from 'src/app/hooks/permissions-hook';
import { ProtectedPage } from 'src/app/routers/ProtectedRoute';

function CampaignTabsPage() {
  const permission = usePermissions()

  return (
    <>
      {permission.setVisibleByAccess(
        [
          "manage_campaign_point.read",
          "history_campaign.read",
          "manage_campaign_lucky_draw.read",
          "manage_campaign_sales_promo.read"
        ],
        <PageTabs
          baseRoute={CampaignScreens.LIST_CAMPAIGN.PATH}
          title={CampaignScreens.CAMPAIGN.TITLE}
          data={campaignTabs}
        />,
        <ProtectedPage {...CampaignScreens.CAMPAIGN} />
      )}
    </>
  );
}

export default CampaignTabsPage;
